export const COLUMN_SIZE = 7;
export const BOARD_SIZE = 7 * COLUMN_SIZE;

export const MIN_DROPS = 5;
export const MAX_DROPS = 30;

export const LEVEL_UP_BONUS = 7_000;
export const LEVEL_UP_BONUS_BLITZ = 17_000;
export const BOARD_CLEAR_BONUS = 70_000;

export const SEQUENCE_MODE_SEED = 'sequencemode';

export const ANIMATION_DURATION = 900; // ms
export const ANIMATION_COOLDOWN = 100; // ms
